<fin-mmb-purchase-success
  *ngIf="(orderStatus$ | async) !== OrderStatus.PENDING; else loader"
  [order$]="order$"
  [paymentMethods$]="paymentMethods$"
  [orderStatus$]="orderStatus$"
  (loadOrderErrorClick)="queueOrderLoad()"
/>

<ng-template #loader>
  <div class="align-center fill">
    <fcom-loader [loaderType]="LoaderTheme.INLINE" />
  </div>
</ng-template>
